import { Stack, Typography } from "@mui/material";
import React from "react";

const NuclideInfo = ({ selectedNuclide }) => {
  const elementName = selectedNuclide?.getElementName?.();

  let Content = null;
  if (selectedNuclide.primary_decay === "Stable") {
    Content = (
      <span>
        This form of {elementName} is <b className="stable-element">Stable</b>
      </span>
    );
  } else if (selectedNuclide.primary_decay === "Unknown") {
    Content = (
      <span>
        The stability of {elementName} is{" "}
        <b className="unknown-element">Unknown</b>
      </span>
    );
  } else {
    Content = (
      <span>
        This form of {elementName} is{" "}
        <b className="radioactive-element">Radioactive</b> <br />
        It emits{" "}
        <b className="radioactive-element">
          {selectedNuclide.primary_decay} radiation
        </b>
      </span>
    );
  }

  return (
    <Stack minHeight="82px" alignItems="center" justifyContent="center">
      <Typography textAlign="center" variant="body1" lineHeight="1.3">
        {selectedNuclide?.name ? Content : <>Isotope does not exist</>}
      </Typography>
    </Stack>
  );
};

export default React.memo(NuclideInfo);
